import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactModal from "react-modal";

import PlacesAutocomplete from "react-places-autocomplete";

import { lookupOperations } from "app/modules/branches/lookup";
import { filterOperations } from "app/modules/branches/filter";

import "./Search.scss";

// const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
// const GOOGLE_PLACES_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;

const Search = ({ sessionToken }) => {
  const dispatch = useDispatch();

  const inputRef = useRef(null);
  useEffect(() => {
    inputRef.current.focus();
  });

  const [input, setInput] = useState("");
  const [modal, setModal] = useState(false);
  const [currentDistance, setCurrentDistance] = useState(2000);

  const { lookupData } = useSelector((state) => state.branchesData);

  let distance = lookupData && lookupData.distance;

  useEffect(() => {
    if (distance) {
      setCurrentDistance(distance);
    }
  }, [distance]);

  const onInput = useCallback(
    ({ key }) => {
      if (key === "Enter" && input && input !== "") {
        dispatch(lookupOperations.lookup(input, currentDistance));
        dispatch(lookupOperations.lookupRequest());
      }
    },
    [dispatch, input, currentDistance]
  );

  const onSearch = useCallback(() => {
    if (input && input !== "") {
      dispatch(lookupOperations.lookup(input, currentDistance));
      dispatch(lookupOperations.lookupRequest());
    }
  }, [dispatch, input, currentDistance]);

  const onFilterByDistance = useCallback(
    (distance) => {
      setCurrentDistance(distance);
      if (input) {
        dispatch(filterOperations.filter(distance));
        dispatch(filterOperations.filterRequest(distance));
      }
    },
    [dispatch, input]
  );

  const onSelectSuggestion = (address) => {
    setInput(address);
    if (address && address !== "") {
      dispatch(lookupOperations.lookup(address, currentDistance));
      dispatch(lookupOperations.lookupRequest());
    }
  };

  ReactModal.setAppElement("#root");

  return (
    <div className="search">
      <PlacesAutocomplete
        searchOptions={{
          componentRestrictions: { country: "ph" },
          sessionToken,
        }}
        value={input}
        onSelect={(address) => onSelectSuggestion(address)}
        onChange={(address) => setInput(address)}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => [
          <div key="input" className="search__control">
            <span className="search__input">
              <input
                {...getInputProps({
                  placeholder: "Tap here to search for an address...",
                  className: "location-search__input",
                })}
                ref={inputRef}
                autoComplete="off"
                // // placeholder="Please input your address..."
                // value={input}
                // onChange={({target: {value}}) => setInput(value)}
                onKeyPress={onInput}
              />
              <button className="search__input-button" onClick={onSearch}>
                <span className="fa fa-search fa-lg"></span>
              </button>
            </span>
            <span
              className="fa fa-bars fa-2x search-filter"
              onClick={() => setModal(!modal)}
            ></span>
          </div>,
          <div key="output" className="search__result">
            {suggestions.length > 0 && (
              <div className="search__result--dropdown-container">
                {loading ? (
                  <div className="search__result-item"> Loading...</div>
                ) : (
                  suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "search__result-item--active"
                      : "search__result-item";
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };

                    const key = `${Date.now()}-${suggestion.placeId}`;
                    return (
                      <div
                        key={key}
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>,
        ]}
      </PlacesAutocomplete>

      <ReactModal
        className="search__modal"
        overlayClassName="overlay"
        isOpen={modal}
        onRequestClose={() => setModal(!modal)}
      >
        <span
          className="fa fa-times-circle fa-lg search__modal-close"
          onClick={() => setModal(!modal)}
        ></span>
        <h3 className="search__modal-header">NEARBY BRANCHES</h3>
        <hr />
        <button
          className="search__modal-button-block"
          disabled={currentDistance === 2 * 1000}
          onClick={() => setCurrentDistance(2 * 1000)}
        >
          2km away
        </button>
        <button
          className="search__modal-button-block"
          disabled={currentDistance === 5 * 1000}
          onClick={() => setCurrentDistance(5 * 1000)}
        >
          5km away
        </button>

        <button
          className="search__modal-button-filter"
          onClick={() => {
            onFilterByDistance(currentDistance);
            setModal(!modal);
          }}
        >
          FILTER
        </button>
      </ReactModal>
    </div>
  );
};

export default Search;
